import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-permission-denied-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title class="flex items-center gap-2">
      <mat-icon color="warn">lock</mat-icon>
      Permiso denegado
    </h2>
    <div mat-dialog-content>
      <p class="mb-2">No tienes permisos para realizar esta acción.</p>
      <p class="text-sm text-gray-600">Si crees que es un error, comunícate con el administrador del sistema.</p>
      <p *ngIf="data?.feature" class="mt-2 text-xs text-gray-500">Funcionalidad: {{ data.feature }}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button color="primary" (click)="close()">Entendido</button>
    </div>
  `,
})
export class PermissionDeniedDialogComponent {
  constructor(
    private ref: MatDialogRef<PermissionDeniedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { feature?: string }
  ) {}

  close() { this.ref.close(); }
}
